// extracted by mini-css-extract-plugin
export default {"btn":"LightBtn_btn__ysjwb","head":"LightBtn_head__rHUzg","btn1":"LightBtn_btn1__y1kPS","head1":"LightBtn_head1__Q8qHw"};